import {CanActivateFn, Router} from '@angular/router';
import {AuthService} from '../service/auth.service';
import {inject} from '@angular/core';
import {MsgService} from '../service/msg.service';

export const defaultAuthGuardGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const msgService = inject(MsgService);
  const router = inject(Router);

  if (authService.logado()) {
    if (!authService.possuiAcessoRotina(route.url[0].path)) {
      msgService.msgAdvertencia('Você não tem acesso a essa rotina.');
      router.navigate(['/index']);
    } else {
      authService.salvarUltimaRotinaAcessada(state.url);
    }
    return true;
  } else {
    router.navigate(['/login']);
    return false;
  }
};
